import { Svg, Path } from 'react-native-svg';

export const Lock = ({ style: { tintColor } }: Props) => {
	return (
		<Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
			<Path
				d="M18.75 24H5.25C4.01 24 3 22.991 3 21.75V11.25C3 10.009 4.01 9 5.25 9H18.75C19.99 9 21 10.009 21 11.25V21.75C21 22.991 19.99 24 18.75 24ZM5.25 10.5C4.837 10.5 4.5 10.836 4.5 11.25V21.75C4.5 22.164 4.837 22.5 5.25 22.5H18.75C19.163 22.5 19.5 22.164 19.5 21.75V11.25C19.5 10.836 19.163 10.5 18.75 10.5H5.25Z"
				fill={tintColor}
			/>
			<Path
				d="M16.5 9V6C16.5 3.519 14.481 1.5 12 1.5C9.519 1.5 7.5 3.519 7.5 6V9H6V6C6 2.691 8.691 0 12 0C15.309 0 18 2.691 18 6V9H16.5Z"
				fill={tintColor}
			/>
			<Path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 15C10 13.897 10.897 13 12 13C13.103 13 14 13.897 14 15C14 15.8379 13.4824 16.5569 12.75 16.8541V19.2499C12.75 19.6639 12.414 19.9999 12 19.9999C11.586 19.9999 11.25 19.6639 11.25 19.2499V16.8541C10.5176 16.5569 10 15.8379 10 15ZM11.5 15C11.5 14.724 11.725 14.5 12 14.5C12.275 14.5 12.5 14.724 12.5 15C12.5 15.276 12.275 15.5 12 15.5C11.725 15.5 11.5 15.276 11.5 15Z"
				fill={tintColor}
			/>
		</Svg>
	);
};

type Props = {
	style: {
		tintColor: string;
	};
};
